/**
 * @file extract the logic of furikomi/p24 for opc and payment-management
 */

import { updatePaymentSetup, updatePayMethod } from '../../../apis/payment'
import { APM_PAYMENT_METHODS } from '../../../utils/payment'
import { APM } from '../../../common/constant'

export default {
  methods: {
    async setupDefaultPaymentMethodForFurikomiAndP24() {
      const { result } = await updatePaymentSetup({
        payload: {
          apmData: {
            zmPaymentMethodId: this.apmPaymentMethodId,
            apmName: this.apmPaymentMethodName
          }
        },
        email: this.getEmail
      })
      if (this.apmPaymentMethodName === APM_PAYMENT_METHODS.P24 && !result?.result?.p24SetupSuccess) {
        throw new Error('p24 setup unsuccessful')
      }
      if (this.apmPaymentMethodName === APM_PAYMENT_METHODS.FURIKOMI && !result?.result?.furikomiSetupSuccess) {
        throw new Error('furikomi setup unsuccessful')
      }

      const { result: res } = await updatePayMethod({
        apmData: {
          apmName: this.apmPaymentMethodName,
          payRespose: JSON.stringify({
            integrationType: APM
          })
        },
        paymentInfo: {
          zAccountId: this.zAccountId
        }
      })
      if (!res?.isExternalAPMMethod) {
        throw new Error('default payment is not APM')
      }
    }
  }
}
